const APP_NAME = `@${process.env.REACT_APP_NAME?.replaceAll(
	" ",
	"_"
).toUpperCase()}`;

const Keys = {
	language: `${APP_NAME}_language`,
	isLoggedIn: `${APP_NAME}_isLoggedIn`,
	isLoading: `${APP_NAME}_isLoading`,
	token: `${APP_NAME}_token`,
	user: `${APP_NAME}_user`,
	propertiesReloadCounter: `${APP_NAME}_propertiesReloadCounter`
};

export default Keys;
